import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

const FileCard = ({ file, onDelete, onDownload, showDelete = true }) => {
if(!file || !file.name) return null;
  return(
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      border: '1px solid #eee',
      borderRadius: 2,
      p: 1,
      minWidth: 100,
      background: '#fff',
      m: 1,
      boxShadow: 1,
    }}
  >
    <InsertDriveFileIcon sx={{ color: '#A6A5A5', mr: 1 }} />
    <Typography
      variant="body2"
      noWrap
      sx={{ maxWidth: 100, flex: 1, fontWeight: 500 }}
      title={file?.name}
    >
      {file?.name?.length > 12 ? `${file?.name?.slice(0, 5)}...` : file?.name}
    </Typography>
    <Typography sx={{ fontSize: 11, color: '#A6A5A5', mx: 1 }}>
      {file?.size > 1024 ? `${(file?.size / 1024).toFixed(2)} KB` : `${file?.size} `}
    </Typography>
    <IconButton size="small" onClick={onDownload}>
      <ArrowDownwardIcon />
    </IconButton>
    {showDelete && (
      <IconButton size="small" onClick={onDelete}>
        <DeleteOutline />
      </IconButton>
    )}
  </Box>
)};

export default FileCard; 